export default {
  methods: {
    createErrorStringFromResponse (responseData, errorString = '') {
      if (responseData.hasOwnProperty('Result')) {
        return responseData['Result']
      } else {
        for (let errorField of Object.entries(responseData)) {
          errorString += errorField[0] + ' - '
          if (Array.isArray(errorField[1])) {
            for (let individualError of errorField[1]) {
              errorString += individualError + ' '
            }
          } else if (errorField[1].hasOwnProperty('0')) {
            errorString = this.createErrorStringFromResponse(errorField[1]['0'], errorString)
          }
        }
      }
      return errorString
    },
    backupResizeToParentInCaseAuthViewOneFails () {
      let resize = () => {
        window.AP.sizeToParent()
      }
      setTimeout(resize, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utils.js